import {
  Component,
  OnInit,
  AfterViewChecked,
  OnDestroy,
} from "@angular/core";
import { ViewStateService } from "../../../shared/services/view-state.service";
import { UserService } from "../../../shared/services/user.service";

import { PractitionerService } from "../../../practitioner/shared/services/practitioner.service";
import { takeUntil } from "rxjs/operators";
import { Subject } from "rxjs";
@Component({
  selector: "app-badge-management",
  templateUrl: "./badge-management.component.html",
  styleUrls: ["./badge-management.component.css"],
})
export class BadgeManagementComponent
  implements OnInit, AfterViewChecked, OnDestroy
{
  personId: string;
  script: boolean;
  person: any;
  badgeCode: string;
  myLocation: string;
  private destroy$ = new Subject<void>();

  constructor(
    private practitionerService: PractitionerService,
    private viewState: ViewStateService,
    private userService: UserService,
  ) {}
  ngOnInit() {
    this.personId = this.userService.CurrentUser.personId;
    this.handleFormResult();
    this.personId = this.userService.CurrentUser.personId;
    this.myLocation = location.host;
    this.script = true;
  }
  ngAfterViewChecked() {
    const acc = document.getElementsByClassName("accordion");
    if (acc.length !== 0 && this.script) {
      this.script = false;
      let i;
      for (i = 0; i < acc.length; i++) {
        acc[i].addEventListener("click", function () {
          this.classList.toggle("active");
          const panel = this.nextElementSibling;
          if (panel.style.maxHeight) {
            panel.style.maxHeight = null;
          } else {
            panel.style.maxHeight = panel.scrollHeight + "px";
          }
        });
      }
    }
  }
  
  private handleFormResult() {
    this.viewState.startLoading();

    this.practitionerService
      .getBadge(this.personId)
      .pipe(takeUntil(this.destroy$))
      .subscribe(
        (res) => {
          this.person = res;
          this.badgeCode = this.person.badgeCode;
          this.viewState.stopLoading();
        },
        (_e) => {
          this.viewState.stopLoading();
        }
      );
  }

  validBadge() {
    if (this.person && this.person.certifications) {return true;}
    else {return false;}
  }

  ngOnDestroy(): void {
    this.destroy$.next();
    this.destroy$.complete();
  }
}
